import React from 'react';
import {
  ApiBlueprint,
  PageBlueprint,
  createFrontendModule,
  createRouteRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Entity } from '@backstage/catalog-model';
import { cloudrunHealthApiRef, CloudrunHealthClient } from './api';

export const isCloudrunHealthAvailable = (entity: Entity): boolean => {
  const annotations = entity.metadata?.annotations || {};
  return Boolean(
    annotations['google.com/cloud-run-service'] ||
      annotations['gcp.myralis.com.br/cloud-run-service'] ||
      annotations['google.com/cloud-run-job'] ||
      annotations['gcp.myralis.com.br/cloud-run-job'],
  );
};

const cloudrunHealthApiOverride = ApiBlueprint.make({
  params: define =>
    define({
      api: cloudrunHealthApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CloudrunHealthClient({ discoveryApi, fetchApi }),
    }),
});

const cloudrunHealthContent = EntityContentBlueprint.make({
  name: 'cloudrun-health',
  params: {
    path: '/health',
    title: 'Health',
    filter: isCloudrunHealthAvailable,
    loader: async () => {
      const { EntityCloudrunHealthContent } = await import(
        './components/EntityCloudrunHealthContent'
      );
      return React.createElement(EntityCloudrunHealthContent, null);
    },
  },
});

const systemHealthRouteRef = createRouteRef();

const systemHealthPage = PageBlueprint.make({
  params: {
    path: '/system-health',
    routeRef: systemHealthRouteRef,
    loader: async () => {
      const { SystemHealthPage } = await import('./components/SystemHealthPage');
      return React.createElement(SystemHealthPage, null);
    },
  },
});

export const cloudrunHealthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    cloudrunHealthApiOverride,
    cloudrunHealthContent,
    systemHealthPage,
  ],
});
